export default function generateWhatsAppURL(number, text) {
    return "https://wa.me/" + number + "?text=" + encodeURIComponent(text);
}